import {FC, useEffect, useRef, useCallback} from 'react'
import {useAuth} from './Auth'
import {getLoginAppPath, removeAuth} from './AuthHelpers'

const INACTIVITY_LIMIT_MS = 10 * 60 * 1000 // 10 minutes d'inactivité

const InactivityLogout: FC = () => {
  const {logout, auth} = useAuth()
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const doLogout = useCallback(() => {
    logout()
    removeAuth()
    localStorage.removeItem('token')
    localStorage.removeItem('expirationTime')
    localStorage.removeItem('role')
    window.location.replace(getLoginAppPath())
  }, [logout])

  const resetTimer = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }
    timerRef.current = setTimeout(() => {
      doLogout()
    }, INACTIVITY_LIMIT_MS)
  }, [doLogout])

  useEffect(() => {
    if (!auth) {
      return
    }

    const activityEvents: (keyof WindowEventMap)[] = [
      'mousemove',
      'mousedown',
      'keydown',
      'touchstart',
      'scroll',
      'click',
    ]

    const handleUserActivity = () => {
      resetTimer()
    }

    activityEvents.forEach((event) => {
      window.addEventListener(event, handleUserActivity, {passive: true})
    })

    resetTimer()

    return () => {
      activityEvents.forEach((event) => {
        window.removeEventListener(event, handleUserActivity)
      })
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }
    }
  }, [auth, resetTimer])

  return null
}

export {InactivityLogout}
